import { useLazyLoadQuery } from "react-relay";
import { graphql } from "babel-plugin-relay/macro";
import {
  DashboardQuery,
  RunnerStatus,
} from "./__generated__/DashboardQuery.graphql";
import React from "react";
import { Alert, IconButton, Link, Stack } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Link as RouterLink } from "react-router-dom";

function Dashboard() {
  const data = useLazyLoadQuery<DashboardQuery>(
    graphql`
      query DashboardQuery {
        viewer {
          organizations {
            name
            runners {
              status
            }
          }
        }
      }
    `,
    {},
  );
  var alert = null;
  if (!data.viewer) {
    window.location.replace("/login/github");

    return;
  }
  if (data.viewer && !data.viewer.organizations.length) {
    alert = (
      <Alert
        variant="filled"
        severity="warning"
        action={
          <IconButton
            onClick={() =>
              window.open("https://github.com/apps/cirrus-runners", "_blank")
            }
          >
            <OpenInNewIcon />
          </IconButton>
        }
      >
        Doesn't see any of your organization has enabled Cirrus Runners App
      </Alert>
    );
  }
  if (data.viewer && data.viewer.organizations.length === 1) {
    window.location.href = "/dashboard/" + data.viewer.organizations[0].name;
  }

  function countRunningRunners(
    runners: ReadonlyArray<{ readonly status: RunnerStatus }>,
  ) {
    return runners.filter((runner) => runner.status === "RUNNING").length;
  }

  let organizations = Array(...(data.viewer?.organizations ?? []));
  organizations
    .sort((a, b) => a.name.localeCompare(b.name))
    .sort(
      (a, b) =>
        -(countRunningRunners(a.runners) - countRunningRunners(b.runners)),
    );
  return (
    <Stack alignItems="center" gap={4}>
      {alert}
      {organizations.map((organization) => (
        <Link
          component={RouterLink}
          key={organization.name}
          to={"/dashboard/" + organization.name}
        >
          {organization.name} ({countRunningRunners(organization.runners)})
        </Link>
      ))}
    </Stack>
  );
}

export default Dashboard;
